import { queryReturnsConfirmationDataSchema } from "@redotech/redo-model/agents/platform-agents/settings/hyper-link-confirmation";
import { ToolComponentProps } from "@redotech/redo-web/ai/chat/types/tool-component-props";
import { CreateHyperLinkTool } from "./create-hyper-link-tool";

export function QueryReturnsTool(props: ToolComponentProps) {
  const parsed = queryReturnsConfirmationDataSchema.safeParse(
    props.confirmationData,
  );
  if (parsed.success) {
    const hyperLinkData =
      parsed.data.innerConfirmationData.innerConfirmationData;
    return <CreateHyperLinkTool {...props} confirmationData={hyperLinkData} />;
  }
  return null;
}
